import { BlogsPage } from '@/pages/marketing/BlogsPage'
import { BlogPostPage } from '@/pages/marketing/BlogPostPage'
import { loginRedirectLoader } from '@/app/login-redirect'
import { MarketingLayout } from '@/app/marketing-layout'
import { AboutPage } from '@/pages/marketing/AboutPage'
import { BrokerageIntegrationsPage } from '@/pages/marketing/BrokerageIntegrationsPage'
import { FoundingTradersPage } from '@/pages/marketing/FoundingTradersPage'
import { MarketIntelligencePage } from '@/pages/marketing/MarketIntelligencePage'
import { MeetIvyPage } from '@/pages/marketing/MeetIvyPage'
import { NewsroomPage } from '@/pages/marketing/NewsroomPage'
import { NotFoundPage } from '@/pages/marketing/NotFoundPage'
import { PortfolioIntelligencePage } from '@/pages/marketing/PortfolioIntelligencePage'
import { PressReleasePage } from '@/pages/marketing/PressReleasePage'
import { PricingPage } from '@/pages/marketing/PricingPage'
import { PlatformDisclaimerPage } from '@/pages/marketing/PlatformDisclaimerPage'
import { PrivacyPolicyPage } from '@/pages/marketing/PrivacyPolicyPage'
import { ResearchIntelligencePage } from '@/pages/marketing/ResearchIntelligencePage'
import { ResponsibleUsePage } from '@/pages/marketing/ResponsibleUsePage'
import { SupportPage } from '@/pages/marketing/SupportPage'
import { TermsOfServicePage } from '@/pages/marketing/TermsOfServicePage'

export const appRoutes = [
  {
    element: <MarketingLayout />,
    children: [
      { path: '/', element: <MeetIvyPage /> },
      { path: '/features/portfolio-intelligence', element: <PortfolioIntelligencePage /> },
      { path: '/features/market-intelligence', element: <MarketIntelligencePage /> },
      { path: '/features/research-intelligence', element: <ResearchIntelligencePage /> },
      { path: '/features/brokerage-integrations', element: <BrokerageIntegrationsPage /> },
      { path: '/pricing', element: <PricingPage /> },
      { path: '/founding-traders', element: <FoundingTradersPage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/support', element: <SupportPage /> },
      { path: '/blogs', element: <BlogsPage /> },
      { path: '/blogs/:year', element: <BlogsPage /> },
      { path: '/blogs/:year/:month', element: <BlogsPage /> },
      { path: '/blogs/:year/:month/:day', element: <BlogsPage /> },
      { path: '/blogs/:year/:month/:day/:slug', element: <BlogPostPage /> },
      { path: '/newsroom', element: <NewsroomPage /> },
      { path: '/newsroom/:slug', element: <PressReleasePage /> },
      { path: '/legal/terms', element: <TermsOfServicePage /> },
      { path: '/legal/privacy', element: <PrivacyPolicyPage /> },
      { path: '/legal/responsible-use', element: <ResponsibleUsePage /> },
      { path: '/legal/platform-disclaimer', element: <PlatformDisclaimerPage /> },
      { path: '/login', loader: loginRedirectLoader, element: null },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
